import { EAvailabilityMode } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";

// Check if Performance add-on is enabled
export const isPerformanceAddOnEnabled = (): boolean => {
    return swSettings.components.PerformanceAddOn.resources.AvaliabilityMode === EAvailabilityMode.OPEN;
};
